import React, { useLayoutEffect, useMemo, useRef } from 'react';
import { buildWireLayers, wireFrame } from '../utils/boardWires';
import { placeWires } from '../utils/placeCamera';

function BoardWires({ edges, tasks, cameraRef }) {
  const svgRef = useRef(null);
  const layers = useMemo(() => buildWireLayers(edges, tasks), [edges, tasks]);
  const frame = useMemo(() => wireFrame(layers), [layers]);
  useLayoutEffect(() => {
    if (!frame || !svgRef.current || !cameraRef?.current) return;
    placeWires(svgRef.current, cameraRef.current, { bake: true });
  }, [frame, cameraRef]);
  if (!frame) return null;
  return (
    <svg
      ref={svgRef}
      className="board-view__wires"
      data-wire-min-x={frame.minX}
      data-wire-min-y={frame.minY}
      data-wire-w={frame.width}
      data-wire-h={frame.height}
      viewBox={`${frame.minX} ${frame.minY} ${frame.width} ${frame.height}`}
    >
      {layers.map((layer) => (
        <g key={layer.key}>
          <path
            d={layer.lines}
            fill="none"
            stroke={layer.stroke}
            strokeWidth={layer.width}
            strokeDasharray={layer.dash}
            strokeLinejoin="round"
            strokeLinecap="round"
            className={layer.dash !== 'none' ? 'board-view__wires-dash' : undefined}
          />
          {layer.arrows ? (
            <path
              d={layer.arrows}
              fill="none"
              stroke={layer.stroke}
              strokeWidth={layer.width}
              strokeLinejoin="round"
              strokeLinecap="round"
            />
          ) : null}
        </g>
      ))}
    </svg>
  );
}

export default BoardWires;
